export const Constant = {
    DEFAULT: 1,
    AIRPORT: 2,
    PORT: 3,
};
export const GroupRates = {
    BASIC_PLUS: "Basic Plus",
    ALL_INCLUSIVE_MAX: "All Inclusive Max"
};
export const Engine = {
    ELECTRIC: "E",
    FUEL: "R"
};
